import { render, staticRenderFns } from "./VSector.vue?vue&type=template&id=66bdff92&"
import script from "./VSector.vue?vue&type=script&lang=js&"
export * from "./VSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports